import { Component, Inject, OnInit, ChangeDetectionStrategy, EventEmitter, ChangeDetectorRef, Input, Optional, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { ServiceItem } from 'src/app/modules/status-page/shared/models/service.models';
import { ServiceGroup } from 'src/app/modules/status-page/service-catalog/service-groups-list/service-groups-list.component';
import { nonWhitespaceHtmlValidator, sanitizeInputForCrossSiteScriptCharactersDom } from 'src/app/_theme/core/_base/curd/utils/validators-util';

export interface ServiceDialogData {
    mode: 'add' | 'edit';
    entityType?: 'service' | 'group';
    service?: ServiceItem;
    group?: ServiceGroup;
    groupId?: string;
}

@Component({
    selector: 'app-service-dialog',
    templateUrl: './service-dialog.component.html',
    styleUrls: ['./service-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule
]
})
export class ServiceDialogComponent implements OnInit {
    serviceForm: FormGroup;
    isSaving: boolean = false;
    @Input() data: ServiceDialogData = { mode: 'add', entityType: 'service' };
    @Output() saveAction = new EventEmitter<any>();
    @Output() closed = new EventEmitter<void>();

    constructor(
        @Optional() public dialogRef: MatDialogRef<ServiceDialogComponent> | null,
        @Optional() @Inject(MAT_DIALOG_DATA) private readonly dialogData: ServiceDialogData | null,
        private readonly fb: FormBuilder,
        public cdr: ChangeDetectorRef,
        private readonly sanitizer: DomSanitizer
    ) {
        this.serviceForm = this.fb.group({
            name: ['', [
                Validators.required,
                Validators.minLength(3),
                nonWhitespaceHtmlValidator(),
                sanitizeInputForCrossSiteScriptCharactersDom(this.sanitizer)
            ]],
            description: ['', [sanitizeInputForCrossSiteScriptCharactersDom(this.sanitizer)]]
        });
    }

    ngOnInit(): void {
        if (this.dialogData) {
            this.data = this.dialogData;
        }
    }

    onCancel(): void {
        if (this.isSaving) {
            return;
        }

        if (this.dialogRef) {
            this.dialogRef.close();
            return;
        }

        this.closed.emit();
    }

    onSave(): void {
        if (this.serviceForm.invalid) {
            this.serviceForm.markAllAsTouched();
            return;
        }

        const formData = {
            ...this.serviceForm.getRawValue(),
            groupId: this.data.groupId
        };

        this.isSaving = true;
        this.cdr.markForCheck();
        this.saveAction.emit({ formData });
    }
}
